import { render, staticRenderFns } from "./UpdateChannelModal.vue?vue&type=template&id=88cad5f8"
import script from "./UpdateChannelModal.vue?vue&type=script&lang=js"
export * from "./UpdateChannelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports